import { render, staticRenderFns } from "./HierarquiaDialog.vue?vue&type=template&id=563c1e7c&"
import script from "./HierarquiaDialog.vue?vue&type=script&lang=js&"
export * from "./HierarquiaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports